import api from './api';

export const inventoryService = {
  getSummary: () => api.get('/inventory/summary').then(response => response.data),
  getItems: (params = {}) => api.get('/inventory/items', { params }).then(response => response.data),
  getItem: id => api.get(`/inventory/items/${id}`).then(response => response.data),
  createItem: data => api.post('/inventory/items', data).then(response => response.data),
  updateItem: (id, data) => api.put(`/inventory/items/${id}`, data).then(response => response.data),
  archiveItem: id => api.delete(`/inventory/items/${id}`).then(response => response.data),
  getLocations: () => api.get('/inventory/locations').then(response => response.data),
  createLocation: data => api.post('/inventory/locations', data).then(response => response.data),
  updateLocation: (id, data) => api.put(`/inventory/locations/${id}`, data).then(response => response.data),
  getMovements: (params = {}) => api.get('/inventory/movements', { params }).then(response => response.data),
  createMovement: data => api.post('/inventory/movements', data).then(response => response.data),
};
